import { accessToken } from "../components/core/auth-service/auth-service";
import {
  FETCH_TICKETS_BEGIN,
  FETCH_TICKETS_SUCCESS,
  FETCH_TICKETS_FAILURE
} from "./actionTypes";
import getConfig from "../environment";
import {ErrorResponseWrapper} from "../model/ErrorResponseWrapper";
import {GetTicketsRequest} from "../model/GetTicketsRequest";

export const fetchTicketsBegin = request => ({
  type: FETCH_TICKETS_BEGIN,
  payload: request
});

export const fetchTicketsSuccess = (ticketsResponse) =>({
  type: FETCH_TICKETS_SUCCESS,
  payload: { ticketsResponse }
});

export const fetchTicketsFailure = errors => ({
  type: FETCH_TICKETS_FAILURE,
  payload: { errors }
});

const TICKETS_TRACKING_API = getConfig()?.ticketsTrackingApi;

export async function getTickets(
    dispatch:any,
    request: GetTicketsRequest,
    merge: boolean = false,
    tickets: any,
    baseSiteUID:string,
    salesAreaDependantCustomerUid:string,
    currentLanguage:string
  )
{
  const url = `${TICKETS_TRACKING_API}${request.toQueryString()}`;
  dispatch(fetchTicketsBegin(request));
  return fetch(url, {
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'PT-Base-Site-UID': `${baseSiteUID}`,
      'PT-Sales-Area-Dependent-Customer-Uid': `${salesAreaDependantCustomerUid}`,
      'Accept-language': currentLanguage,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then( res => {
    if (!res.ok) {
      throw new ErrorResponseWrapper(res)
    } else {
      return res.json();
    }
  })
  .then( data => {
    if (merge) {
      data.tickets = [...tickets, ...data.tickets];
    }
    dispatch(fetchTicketsSuccess(data));
    return(data);
  })
  .catch((errorResponse: ErrorResponseWrapper) => {
    dispatch(fetchTicketsFailure(errorResponse));
  });
}
